(function ($) {
    $(function () {
        $('.curtain').has('[data-gmaps]').one('curtain-changed', function () {
            $(this).find('[data-gmaps]').trigger('gmaps-init');
        });
    });
}(jQuery));
